<!-- Go paperless initiation. Sign Up/Opt Out -->
<div class="go-paperless-promo">
  @if (!isEnrolled) {
    <div>
      <div class="pad-bottom-20">
        <p>
          <span dsContent [contentPath]="'goPaperless.forMoreInfoText'"></span>
          <a dsRouterLink="/faq/go-paperless"
            ><span dsContent [contentPath]="'goPaperless.paperlessFAQ'"></span></a
          >.
        </p>
      </div>
      <div class="pad-top-20">
        <p>
          <span> <strong dsContent [contentPath]="'goPaperless.note'"></strong></span
          ><span dsContent [contentPath]="'goPaperless.paperlessDocsNotAvailableMessage'"> </span>
        </p>
      </div>
      <div>
        <hr aria-hidden="true" class="dashed" />
        <div class="row">
          <div class="column twelve md-nine pad-top-10">
            <span data-cy="goPaperlessSignUpContent"
              ><strong dsContent [contentPath]="'goPaperless.enrollInPaperless'"></strong
            ></span>
          </div>
          <div class="column twelve md-three text-right">
            <button
              ds-button
              type="button"
              (click)="enroll()"
              authCheck
              [permissionName]="'enrollpaperlesspolicydocs_submit'"
              [checkAction]="'disable'"
              dsContent
              [contentPath]="'goPaperless.signUpButton'"
              data-cy="goPaperlessSignUpBtn"
            ></button>
          </div>
        </div>
      </div>
    </div>
  }
  @if (isEnrolled) {
    <div>
      <div class="pad-bottom-20">
        <p class="note" dsContent [contentPath]="'goPaperless.paperPolicyNote'"></p>
      </div>
      <div class="pad-top-20">
        <p>
          <span> <strong dsContent [contentPath]="'goPaperless.note'"></strong></span>
          <span dsContent [contentPath]="'goPaperless.paperlessDocsNotAvailableMessage'"></span>
        </p>
      </div>
      <div>
        <hr aria-hidden="true" class="dashed" />
        <div class="row">
          <div class="column twelve md-nine">
            <span>
              <strong dsContent [contentPath]="'goPaperless.enrollPaperlessTitle'"></strong
            ></span>
            <p class="note pad-top-20">
              <Span dsContent [contentPath]="'goPaperless.policyDocumentNotifications'"></Span>
              <span>
                <strong>{{ user.emailAddress }}</strong></span
              ><span dsContent [contentPath]="'goPaperless.changeEmailQuestion'"></span>
              <a dsRouterLink="/profile"
                ><span dsContent [contentPath]="'goPaperless.profileTab'"></span></a
              >.
            </p>
          </div>
          <div class="column twelve text-right md-three pad-top-30">
            <button
              ds-button
              type="button"
              (click)="unenroll()"
              authCheck
              [permissionName]="'unregpaperlesspolicydocs_submit'"
              [checkAction]="'disable'"
              dsContent
              [contentPath]="'goPaperless.optOutButton'"
              data-cy="goPaperlessOptOutBtn"
            >
              Opt Out
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
